.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.2rem;
}

/* ─── Phone Frame ─── */
.phone {
  position: relative;
  width: 260px;
  aspect-ratio: 9 / 19.5;
  background: #1a1a22;
  border-radius: 36px;
  border: 3px solid #2a2a33;
  box-shadow:
    0 0 0 1px rgba(255, 255, 255, 0.04),
    0 20px 60px rgba(0, 0, 0, 0.5),
    inset 0 0 30px rgba(0, 0, 0, 0.3);
  overflow: hidden;
}

.notch {
  position: absolute;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  width: 90px;
  height: 24px;
  background: #0c0c0f;
  border-radius: 0 0 16px 16px;
  z-index: 10;
}

.screen {
  position: absolute;
  inset: 0;
  border-radius: 33px;
  overflow: hidden;
}

/* ─── Slides ─── */
.slide {
  position: absolute;
  inset: 0;
  opacity: 0;
  transition: opacity 0.5s ease;
}

.slideActive {
  opacity: 1;
}

/* ─── Controls ─── */
.controls {
  display: flex;
  align-items: center;
  gap: 0.8rem;
}

.arrow {
  background: none;
  border: 1px solid var(--color-border-default, #2a2a33);
  color: var(--color-text-secondary, #8a8a95);
  width: 32px;
  height: 32px;
  border-radius: 50%;
  font-size: 1.2rem;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.2s, color 0.2s;
}

.arrow:hover {
  border-color: var(--accent);
  color: var(--accent);
}

.dots {
  display: flex;
  gap: 0.4rem;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: none;
  background: var(--color-border-default, #2a2a33);
  cursor: pointer;
  padding: 0;
  transition: background 0.3s, transform 0.3s;
}

.dotActive {
  background: var(--accent);
  transform: scale(1.3);
}

/* ─── Responsive ─── */
@media (max-width: 768px) {
  .phone {
    width: 220px;
  }
}
